import { ButtonProps as MUIButtonProps } from "@mui/material/Button/Button";
import { Button as MUIButton } from "@mui/material";
import React from "react";

interface ButtonProps extends MUIButtonProps {
  target?: string;
}

export function Button(props: ButtonProps) {
  return (
    <MUIButton
      {...props}
      sx={{ paddingX: 2, paddingY: 1, textTransform: "none", ...props.sx }}
    >
      {props.children}
    </MUIButton>
  );
}
